import mapboxgl from 'mapbox-gl';
import React, { useEffect, useRef } from 'react';

export const Popup: React.FC<{tipColor?: string, longitude: number, latitude: number, map?: mapboxgl.Map, options?: mapboxgl.PopupOptions}> = ({ tipColor, children, latitude, longitude, map, options }) => {
    // this is a mapbox map instance, you can pass it via props
    const popupRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        let popup: mapboxgl.Popup;
        if(popupRef.current && map){
            popup = new mapboxgl.Popup(options)
                .setLngLat([longitude, latitude])
                .setDOMContent(popupRef.current)
                .addTo(map);
            
            // sets tip color
            if((popup as any)._tip && tipColor){
                const tipDom = (popup as any)._tip;
                tipDom.style['borderTopColor'] = tipColor;
            }
        }

        return () => {popup && popup.remove()};
    }, [children, longitude, latitude, options, tipColor, map]);

    return (
        <div style={{ display: 'none' }}>
            <div ref={popupRef}>
                {children}
            </div>
        </div>
    );
};
